var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoprojecteur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "retro_projecteur",
    "data-name": "retro projecteur"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.45,38.77a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.71h0a.71.71,0,0,1,.71.71A.7.7,0,0,1,27.45,38.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31,38.77a.71.71,0,0,1,0-1.41h0a.71.71,0,0,1,.7.71A.7.7,0,0,1,31,38.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.93,38.77a.71.71,0,1,1,0-1.41h0a.71.71,0,0,1,.71.71A.7.7,0,0,1,23.93,38.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.09,43h-38c-2,0-3.52-2.31-3.52-4.23V28.21a3.53,3.53,0,0,1,3.52-3.53.7.7,0,0,1,.7.71.7.7,0,0,1-.7.7,2.11,2.11,0,0,0-2.11,2.12V38.77c0,1.23,1,2.82,2.11,2.82h38a2.12,2.12,0,0,0,2.11-2.11V28.21a2.12,2.12,0,0,0-2.11-2.12.7.7,0,0,1-.71-.7.71.71,0,0,1,.71-.71,3.53,3.53,0,0,1,3.52,3.53V39.48A3.53,3.53,0,0,1,52.09,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.43,36a7.75,7.75,0,1,1,7.75-7.75A7.76,7.76,0,0,1,27.43,36Zm0-14.09a6.34,6.34,0,1,0,6.34,6.34A6.35,6.35,0,0,0,27.43,21.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.43,33.14a4.93,4.93,0,1,1,4.93-4.93A4.93,4.93,0,0,1,27.43,33.14Zm0-8.46A3.53,3.53,0,1,0,31,28.21,3.53,3.53,0,0,0,27.43,24.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.81,33.14a1.76,1.76,0,1,1,1.76-1.76A1.76,1.76,0,0,1,15.81,33.14Zm0-2.12a.36.36,0,1,0,.35.36A.36.36,0,0,0,15.81,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.81,38.77A1.76,1.76,0,1,1,17.57,37,1.76,1.76,0,0,1,15.81,38.77Zm0-2.11a.35.35,0,0,0-.35.35.35.35,0,1,0,.7,0A.35.35,0,0,0,15.81,36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,28.21a.71.71,0,0,1-.71-.71V25.39a.71.71,0,0,1,.71-.71.7.7,0,0,1,.7.71V27.5A.7.7,0,0,1,38,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.09,28.21H38a.71.71,0,0,1-.71-.71.7.7,0,0,1,.71-.7H52.09a.7.7,0,0,1,.7.7A.7.7,0,0,1,52.09,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.09,28.21a.71.71,0,0,1-.71-.71V25.39a.71.71,0,0,1,.71-.71.7.7,0,0,1,.7.71V27.5A.7.7,0,0,1,52.09,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.91,33.14H38a.71.71,0,0,1-.71-.71.7.7,0,0,1,.71-.7H54.91a.7.7,0,0,1,.7.7A.71.71,0,0,1,54.91,33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.91,36H38a.71.71,0,0,1-.71-.71.7.7,0,0,1,.71-.7H54.91a.7.7,0,0,1,.7.7A.71.71,0,0,1,54.91,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.91,38.77H38a.7.7,0,0,1-.71-.7.71.71,0,0,1,.71-.71H54.91a.71.71,0,0,1,.7.71A.7.7,0,0,1,54.91,38.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.16,45.11a.7.7,0,0,1-.7-.7V42.3a.7.7,0,0,1,.7-.71.71.71,0,0,1,.71.71v2.11A.7.7,0,0,1,16.16,45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.91,45.11H16.16a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.71h7.75a.71.71,0,0,1,.71.71A.7.7,0,0,1,23.91,45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.91,45.11a.7.7,0,0,1-.7-.7V42.3a.7.7,0,0,1,.7-.71.71.71,0,0,1,.71.71v2.11A.7.7,0,0,1,23.91,45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.23,45.11a.7.7,0,0,1-.71-.7V42.3a.71.71,0,0,1,.71-.71.7.7,0,0,1,.7.71v2.11A.7.7,0,0,1,42.23,45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,45.11H42.23a.7.7,0,0,1-.71-.7.71.71,0,0,1,.71-.71H50a.71.71,0,0,1,.71.71A.7.7,0,0,1,50,45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,45.11a.7.7,0,0,1-.7-.7V42.3a.71.71,0,1,1,1.41,0v2.11A.7.7,0,0,1,50,45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,26.09H14.05a.7.7,0,0,1-.71-.7.71.71,0,0,1,.71-.71H21a.71.71,0,0,1,.7.71A.7.7,0,0,1,21,26.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.09,26.09H33.89a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.71h18.2a.7.7,0,0,1,.7.71A.7.7,0,0,1,52.09,26.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.43,18.34a.7.7,0,0,1-.7-.7V14.12a.7.7,0,0,1,.7-.71.71.71,0,0,1,.71.71v3.52A.7.7,0,0,1,27.43,18.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.15,19.76a.72.72,0,0,1-.61-.35l-1.76-3.05a.69.69,0,0,1,.26-1,.7.7,0,0,1,1,.25l1.76,3a.72.72,0,0,1-.26,1A.73.73,0,0,1,22.15,19.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.28,23.63a.64.64,0,0,1-.35-.1l-3-1.76a.7.7,0,1,1,.7-1.22l3,1.76a.71.71,0,0,1,.26,1A.72.72,0,0,1,18.28,23.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.58,23.63a.71.71,0,0,1-.35-1.32l3.05-1.76a.7.7,0,0,1,1,.26.69.69,0,0,1-.26,1l-3,1.76A.7.7,0,0,1,36.58,23.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.72,19.76a.77.77,0,0,1-.36-.09.71.71,0,0,1-.25-1l1.76-3a.71.71,0,0,1,1.22.71l-1.76,3.05A.72.72,0,0,1,32.72,19.76Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoprojecteur);
export default __webpack_public_path__ + "static/media/videoprojecteur.2b1915c38939bfce44dc3c7ee34e51a3.svg";
export { ForwardRef as ReactComponent };